import { Box, Label } from './Checkbox'

export const Checkbox = {
  Label,
  Box,
}
